import { render, staticRenderFns } from "./ProductFooter.vue?vue&type=template&id=66f5b153"
import script from "./ProductFooter.vue?vue&type=script&lang=js"
export * from "./ProductFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports